import { css } from "@emotion/css";
import { Colors, FontWeight } from "@snapchat/snap-design-system";

// SDS styles take precedence otherwise
export const iconButtonCss = css`
    padding-right: 0 !important;
    padding-left: 0 !important;
`;

export const primaryTagCss = css`
    height: 30px;
    padding: 0 10px;

    background-color: ${Colors.Orange.V10};
    border-color: ${Colors.Orange.V10};
    border-radius: 15px;
`;

export const dndCardWrapperDraggingStyle = css`
    opacity: 0.1;
`;

export const dndCardWrapperNormalStyle = css`
    transform: translate(0, 0);
    opacity: 1;
`;

export const emptyCardContainerStyle = css`
    cursor: not-allowed;

    height: 60px;
    margin-top: 0;
    margin-bottom: 5px;
    padding: 5px;

    border-color: ${Colors.Gray.V50};
    border-style: dashed;
    border-width: 2px;
`;

export const emptyCardContentWrapperStyle = css`
    display: flex;
    justify-content: center;
    height: 100%;
`;

export const uploadButtonStyle = css`
    cursor: pointer;

    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;

    padding: 10px;

    font-weight: ${FontWeight.SEMI_BOLD};

    background-color: ${Colors.WHITE};
    border: none;
    border-radius: 15px;
`;

export const filledCardContainerStyle = css`
    cursor: grab;

    height: 60px;
    margin-top: 0;
    margin-bottom: 5px;
    padding: 5px;

    background-color: ${Colors.Gray.V50};
`;

export const hiddenFileInputStyle = css`
    display: none;
`;
